export default "__VITE_ASSET__b44e9686__"